// extracted by mini-css-extract-plugin
export default {"price":"_8-z","onSale":"a9-z","msrpLabelPrice":"b9-z","msrpLabel":"c9-z","originalPrice":"d9-z"};